import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Observer, Subject} from 'rxjs';
import {EntitiesService} from '../entities/entities.service';
import {PusherService} from '../pusher/pusher.service';
import {MessagesService} from '../messages/messages.service';
import {Message} from '../../models/message';
import {Entity} from '../../models/entity';
import {ShardHandlerService} from '../sharding/shard-handler.service';
import {UserService} from '../user/user.service';
import {PushedMessage} from '../../models/pushed-message';
import {ApiService} from '../api/api.service';

/**
 * Use the 'observable' property to subscribe to messages.
 * Use the 'newMessagesCount' property to get an active count of new messages.
 */
@Injectable({
  providedIn: 'root',
})
export class NewMessageObserverService {
  public newMessagesCount = 0;

  private loaded: Promise<null> = null;
  private observable: Subject<PushedMessage> = new Subject();

  constructor(
    private entitiesService: EntitiesService,
    private messagesService: MessagesService,
    private pusher: PusherService,
    private shard: ShardHandlerService,
    private user: UserService,
    private api: ApiService,
  ) {
    const vm = this;

    vm.refreshUnreadCount();

    vm.loaded = new Promise((resolve, reject) => {
      vm.pusher.subscribe('user.' + user.currentUser.id, true).then(channel => {
        channel.bind('chat.message.created', (data) => {
          vm.observable.next(data);
          vm.newMessagesCount++;
        });
        resolve();
      });
    });
  }

  subscribe(next?: (value: PushedMessage) => void, error?: (error: any) => void, complete?: () => void) {
    return this.observable.subscribe(next, error, complete);
  }

  public refreshUnreadCount() {
    const vm = this;

    this.api.get('v1/messages/unread-chat-count').then(data => {
      vm.newMessagesCount = data['data']['unread_chat_message_count'];
    })
  }
}
